import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AffiliatePortalAuthService } from '../services/affiliate-portal-auth.service';
import { AffiliateHostService } from '../services/affiliate-host.service';

/**
 * Guards the protected portal routes.
 *
 * The affiliation is identified by the host (`{subdomain}.partner.atsmako.{tld}`),
 * not the URL path, so the subdomain is read from `AffiliateHostService` rather
 * than the route segments. Redirects to the portal `/login` when there's no
 * valid session for the host's subdomain. Pairs with `partnerHostGuard`, which
 * already guarantees a partner host by the time this runs.
 */
export const affiliatePortalAuthGuard: CanMatchFn = () => {
  const auth = inject(AffiliatePortalAuthService);
  const host = inject(AffiliateHostService);
  const router = inject(Router);

  const subdomain = host.getSubdomain();
  if (!subdomain) {
    return router.createUrlTree(['/login']);
  }

  if (auth.isAuthenticatedForSubdomain(subdomain)) {
    return true;
  }
  // Don't keep a stale (or wrong-subdomain) token sitting in storage.
  auth.clearSession();
  return router.createUrlTree(['/login']);
};
